import axios from 'axios';
import API from '../config/API';

/**
 * Email verification for the silent salon-record sync (beu-be
 * docs/client-flows.md §7.4): the signup code step (complete with { code })
 * and the plain /find-my-bookings page. Nothing client-facing names it.
 *
 * Every call resolves to { ok, data, message } — the API answers failures as
 * HTTP 200 + { statusCode: 0, error }. Signed in, the session token goes on
 * the custom `accessToken` header (what the v2 auth middleware reads) and the
 * server sends the code to the account's OWN email.
 */
function headers(withAuth) {
    const h = { 'Content-Type': 'application/json' };
    const token = withAuth ? localStorage.getItem('accessToken') : null;
    if (token) h.accessToken = token;
    return h;
}

function unwrap(response) {
    const body = (response && response.data) || {};
    if (body.statusCode === 1) return { ok: true, data: body.responseData || {}, message: (body.responseData || {}).message };
    const error = body.error || {};
    return { ok: false, data: error, message: error.responseMessage || 'Something went wrong. Please try again.' };
}

const failed = () => ({ ok: false, data: {}, message: 'We could not reach Beu. Check your connection and try again.' });

function call(method, url, data, withAuth) {
    return axios({ method, url, data, headers: headers(withAuth) }).then(unwrap).catch(failed);
}

export const clientClaimService = {
    status: (withAuth) => call('get', API.CLIENT_CLAIM_STATUS, undefined, withAuth),
    sendCode: (email, withAuth) => call('post', API.CLIENT_CLAIM_SEND_CODE, withAuth ? {} : { email }, withAuth),
    verify: (params, withAuth) => call('post', API.CLIENT_CLAIM_VERIFY, params, withAuth),
    complete: (params) => call('post', API.CLIENT_CLAIM_COMPLETE, params, false)
    // complete: { email, code | claimToken, password, first_name, last_name, phoneNumber? }
};
